import { formatPayRangeAmount } from "@components/utils/formatPayRangeAmount";

const has = (value) => value != null && value !== "";

/** Server-computed position (0-100) or null; never recomputed on the client. */
export function normalizePositionPct(rangePenetration) {
  const raw = rangePenetration?.position_pct;
  if (!has(raw)) return null;
  const pct = Number(raw);
  return Number.isFinite(pct) ? pct : null;
}

export function midRelation(positionPct) {
  if (positionPct === 50) return "at Mid";
  return positionPct < 50 ? "below Mid" : "above Mid";
}

/** "62% of range · above Mid", or "Not available" when there is nothing to place. */
export function formatPenetrationLabel(rangePenetration) {
  const pct = normalizePositionPct(rangePenetration);
  if (pct == null) return "Not available";
  return `${pct}% of range · ${midRelation(pct)}`;
}

export function formatPenetrationAmount(value, currencySymbol = "$") {
  if (!has(value)) return "-";
  const formatted = formatPayRangeAmount(value);
  return formatted === "-" ? "-" : `${currencySymbol}${formatted}`;
}
